import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
} from '@angular/forms';

export function capacitySumValidator(getVolume: () => number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control instanceof FormArray) {
      const volume = getVolume();
      const controls = control.controls;
      const sum = controls
        .map((ctrl) => +ctrl.value || 0)
        .reduce((acc, val) => acc + val, 0);

      // Limpiar errores previos
      controls.forEach((ctrl) => {
        const errors = ctrl.errors;
        if (errors?.['capacityExceedsVolume']) {
          delete errors['capacityExceedsVolume'];
          ctrl.setErrors(Object.keys(errors).length ? errors : null);
        }
      });

      // Si la suma no coincide, establecer errores en los hijos y en el array
      if (sum !== volume) {
        controls.forEach((ctrl) => {
          const errors = ctrl.errors || {};
          errors['capacityExceedsVolume'] = true;
          ctrl.setErrors(errors);
        });

        return { capacitySumMismatch: true }; // <== error a nivel del FormArray
      }
    }

    return null;
  };
}
